export default "__VITE_PUBLIC_ASSET__a6ad2ce6__"